/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import dayjs from 'dayjs';

import type { DatePeriodValue } from '@veeam/components';

export const formatDatePeriod = (dates: DatePeriodValue, format: string): string => {
    if (!Array.isArray(dates)) return '';

    const upperFormat = format.toUpperCase();

    if (dates.length === 1) {
        return dayjs(dates[0]).format(upperFormat);
    } else if (dates.length === 2) {
        return `${dayjs(dates[0]).format(upperFormat)} - ${dayjs(dates[1]).format(upperFormat)}`;
    }

    return '';
};
